export default "__VITE_PUBLIC_ASSET__c29ba343__"